// Generert automatisk av scripts/generate-build-info.js - ikke rediger manuelt.
export const BUILD_TIME = "05.11.2026 kl. 11:32";
export const BUILD_TIME_ISO = "2026-11-05T10:32:22.113Z";
export const BUILD_VERSION = "2026.11.05.11.32";
export const BUILD_LABEL = "Build 2026.11.05.11.32";
